import { map, random, sample } from 'lodash';
import { defaults } from './defaults';
import { generate } from 'randomstring';
export class Fixture {
    static strings(count = 5) {
        return Fixture.multiple(Fixture.string, count);
    }
    static currency() {
        return 'EUR';
    }
    static areaUnit() {
        return 'sqm';
    }
    static numbers({ min = 1, max = 50, count = 5 } = {}) {
        const numbers = [];
        while (numbers.length < count) {
            const number = random(min, max);
            if (!(number in numbers)) {
                numbers.push(number);
            }
        }
        return numbers;
    }
    static timestamp(props = {}) {
        const { year, month, day, hours, minutes, seconds } = defaults(props, {
            year: Fixture.number({ min: 2000, max: 2022 }),
            month: Fixture.number({ min: 1, max: 12 }).toString().padStart(2, '0'),
            day: Fixture.number({ min: 1, max: 28 }).toString().padStart(2, '0'),
            hours: Fixture.number({ min: 0, max: 23 }).toString().padStart(2, '0'),
            minutes: Fixture.number({ min: 0, max: 59 }).toString().padStart(2, '0'),
            seconds: Fixture.number({ min: 0, max: 59 }).toString().padStart(2, '0'),
        });
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.926536Z`;
    }
    static isoDate(props = {}) {
        const { year, month, day } = defaults(props, {
            year: Fixture.number({ min: 2000, max: 2022 }),
            month: Fixture.number({ min: 1, max: 12 }).toString().padStart(2, '0'),
            day: Fixture.number({ min: 1, max: 28 }).toString().padStart(2, '0'),
        });
        return `${year}-${month}-${day}`;
    }
    static uuid() {
        return crypto.randomUUID();
    }
    static email() {
        return `${Fixture.string()}@einwert.com`;
    }
    static url() {
        return `https://${Fixture.string()}.de`;
    }
    static string(length = 5, alphanumeric = false) {
        return generate({ length, charset: alphanumeric ? 'alphanumeric' : undefined });
    }
    static multiple(factory, count = 5) {
        return map(new Array(count), factory);
    }
    static number({ min = 1, max = 100000, not } = {}) {
        const number = random(min, max);
        return number === not ? number + 1 : number;
    }
    static boolean() {
        return Boolean(random(0, 1));
    }
    static sample(input) {
        return sample(input);
    }
}
